"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/**
 * colorConvert() returns a color new array
 * change color value according to lottie values
 */
function colorConvertLottie(colors) {
  var newArray = [];
  var index = 0;
  colors.forEach(function (color) {
    if (++index === 4) {
      // alpha
      newArray.push(color);
    } else {
      // rgb
      newArray.push(color / 255);
    }
  });
  return newArray;
}

var _default = colorConvertLottie;
exports.default = _default;